import { __awaiter, __generator } from "tslib";
import { httpClient } from '../http-client';
import { config } from '../config';
import { mapOriginToQueryParam } from '../common/utils';
import { Order, } from '@wix/ambassador-marketplace/types';
var solutionLimit = 200;
var defaultUserDetails = {
    photo: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iYSIgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiByeD0iMTgiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0RBRUZGRSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPgogICAgICAgIDxwYXRoIGZpbGw9IiNCMUQ5RjciIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTMwIDM1YzAtNS4xMy0zLjIxOC05LjUwNy03Ljc0NS0xMS4yMjRhOCA4IDAgMSAwLTguNTEgMEM5LjIxOCAyNS40OTMgNiAyOS44NzEgNiAzNXYxaDI0di0xeiIgbWFzaz0idXJsKCNiKSIvPgogICAgPC9nPgo8L3N2Zz4K',
};
export var getAppsForSearchBar = function (term) {
    return httpClient
        .get(config.baseApiUrl + "/_api/app-market-api/apps/?filter=" + term + "&lang=en&limit=3&exclude=editor_1.4_incompatible,ecommerce_old&fields=appDefinitionId,name,slug,teaser,appIcon")
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var getSolutionBySlug = function (slug, locale, useNewApi, rpcClient) {
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient
            .getWebSolutionBySlug({ idsOrSlugs: slug, lang: locale })
            .then(function (response) { var _a, _b; return (_b = (_a = response.webSolutions) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null; });
    }
    var baseURl = useNewApi ? 'marketplace-api/v1' : 'app-market-api/v2';
    return httpClient
        .get(config.baseApiUrl + "/_api/" + baseURl + "/web-solutions/" + slug + "?lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data.webSolutions && data.webSolutions.length > 0
            ? data.webSolutions[0]
            : null;
    });
};
export var getPermittedActions = function (msid) {
    return httpClient
        .get(config.baseApiUrl + "/_serverless/app-market-rpc-proxy/market-actions/" + msid)
        .then(function (_a) {
        var data = _a.data;
        return data.body;
    })
        .catch(function (error) { return config.sentryClient.captureException(error); });
};
export var getSolutionPreviewBySlugOrId = function (slugOrId, locale, useNewApi, rpcClient) {
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient
            .getWebSolutionBySlug({
            idsOrSlugs: slugOrId,
            isPreview: true,
            lang: locale,
        })
            .then(function (response) { var _a; return (_a = response.webSolutions) === null || _a === void 0 ? void 0 : _a[0]; });
    }
    var newApiURL = useNewApi ? 'marketplace-api/v1' : 'app-market-api/v2';
    return httpClient
        .get(config.baseApiUrl + "/_api/" + newApiURL + "/web-solutions/" + slugOrId + "?isPreview=true&lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data.webSolutions &&
            data.webSolutions.length > 0 &&
            data.webSolutions[0];
    });
};
export var getReviewesBySolutionId = function (solutionId, sortMethod, offset, limit) {
    if (sortMethod === void 0) { sortMethod = '-publishedAt'; }
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 5; }
    return httpClient
        .get(config.baseApiUrl + "/_serverless/app-market-reviews/" + solutionId + "?sort=" + sortMethod + "&offset=" + offset + "&limit=" + limit, { withCredentials: true })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var getIsEligibleForReviews = function (appid) {
    if (appid) {
        return httpClient
            .get(config.baseApiUrl + "/_serverless/app-market-rpc-proxy/eligible-for-review/" + appid, { withCredentials: true })
            .then(function (_a) {
            var data = _a.data;
            return data === null || data === void 0 ? void 0 : data.eligibleForReview;
        })
            .catch(function (error) { return true; });
    }
    return true;
};
export var getSolutionsBaseBySearchQuery = function (query, locale, apiLimit, apiOffset, rpcClient) {
    if (apiLimit === void 0) { apiLimit = 36; }
    if (apiOffset === void 0) { apiOffset = 0; }
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient
            .getAppsBySearchQuery({
            searchTerm: query,
            languageCode: locale,
            query: { paging: { limit: apiLimit, offset: apiOffset } },
        })
            .then(function (searchResponse) { return ({
            suggestions: searchResponse.webSolutions,
            total: searchResponse.pagingMetadata.total,
        }); });
    }
    return httpClient
        .get(config.baseApiUrl + "/_serverless/app-market-search/search?term=" + query + "&lang=" + locale + "&limit=" + apiLimit + "&offset=" + apiOffset, { withCredentials: true })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var getTagsDataBySlugs = function (slugs, useInReview, locale, countryCode, useNewApi, sortTagsByGeo, rpcClient) {
    if (locale === void 0) { locale = 'en'; }
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient.getWebSolutionsByTags({
            tagsSlug: slugs.join(','),
            limit: solutionLimit,
            lang: locale,
            order: sortTagsByGeo && countryCode ? Order.GEO : undefined,
            country: sortTagsByGeo && countryCode ? countryCode : undefined,
        });
    }
    var baseURl = useNewApi ? 'marketplace-api/v1' : 'app-market-api/v2';
    var sortByGeo = sortTagsByGeo && countryCode ? "&order=GEO&country=" + countryCode : '';
    var url = useInReview
        ? config.baseApiUrl + "/_api/" + baseURl + "/web-solutions/tags/" + slugs.join(',') + "?limit=" + solutionLimit + "&lang=" + locale + sortByGeo
        : config.baseApiUrl + "/_api/" + baseURl + "/web-solutions/tags/" + slugs.join(',') + "?limit=" + solutionLimit + "&lang=" + locale + sortByGeo;
    return httpClient.get(url).then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var getSolutionsBaseBySlugs = function (slugs, locale, countryCode, useNewApi, sortTagsByGeo) {
    var baseURl = useNewApi ? 'marketplace-api/v1' : 'app-market-api/v2';
    var sortByGeo = sortTagsByGeo && countryCode ? "&order=GEO&country=" + countryCode : '';
    return httpClient
        .get(config.baseApiUrl + "/_api/" + baseURl + "/web-solutions/tags/" + slugs.join(',') + "?limit=" + solutionLimit + "&lang=" + locale + sortByGeo)
        .then(function (_a) {
        var data = _a.data;
        return {
            suggestions: data.webSolutions.map(function (solution) { return solution.baseInfo; }),
        };
    });
};
export var getMenuDataByPlatform = function (route, locale, rpcClient) {
    var platform = mapOriginToQueryParam(route);
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient.getContainer({
            platformName: platform,
            containerName: 'menu',
            lang: locale,
        });
    }
    var baseURl = 'marketplace-api/v1';
    return httpClient
        .get(config.baseApiUrl + "/_api/" + baseURl + "/container?platformName=" + platform + "&containerName=menu&lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var getSearcheAppsByQuery = function (term) {
    return httpClient
        .get(config.baseApiUrl + "/_serverless/app-market-search/search?term=" + term)
        .then(function (_a) {
        var data = _a.data;
        return data.suggestions;
    });
};
export var getAutocompleteAppsByQuery = function (term, locale) {
    return httpClient
        .get(config.baseApiUrl + "/_serverless/app-market-search/autocomplete?term=" + term + "&lang=" + locale)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
export var fetchInstalledApps = function (signedInstance) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (signedInstance) {
            return [2 /*return*/, httpClient
                    .get(config.baseApiUrl + "/_api/marketplace-api/v1/managed-apps", {
                    headers: { Authorization: signedInstance },
                })
                    .then(function (res) { return res && res.data && res.data.managedWebSolutions; })
                    .catch(function (error) {
                    console.error('cannot fetch installed apps', error);
                    config.sentryClient.captureException(error);
                })];
        }
        return [2 /*return*/, Promise.resolve([])];
    });
}); };
export var fetchSiteData = function (msid) {
    if (msid) {
        return httpClient
            .get(config.baseApiUrl + "/_serverless/app-market-rpc-proxy/premium-features/" + msid)
            .then(function (res) {
            var result = res.data.body || {};
            var premiumFeatures = (result && result.premiumFeatures) || [];
            var domains = (result && result.domains) || [];
            return {
                siteIsPremium: !!premiumFeatures.length,
                siteHasDomain: !!domains.length,
            };
        })
            .catch(function (error) {
            config.sentryClient.captureException(error);
            return {
                siteIsPremium: true,
                siteHasDomain: true,
            };
        });
    }
    return {
        siteIsPremium: true,
        siteHasDomain: true,
    };
};
export var getCategoriesData = function (locale, rpcClient) {
    var isSSR = typeof window === 'undefined';
    if (isSSR && rpcClient !== undefined) {
        return rpcClient.getCategories({ lang: locale });
    }
    var url = config.baseApiUrl + "/_api/marketplace-api/v1/categories?lang=" + locale;
    return httpClient.get(url).then(function (_a) {
        var data = _a.data;
        return data;
    });
};
var getUserDetailsFromResponse = function (response) {
    if (response && response.user) {
        var user = response.user;
        var username = user.first !== null && user.last !== null
            ? user.first + " " + user.last
            : user.userName;
        return {
            userImage: user.photo ? user.photo : defaultUserDetails.photo,
            username: username,
        };
    }
    return {};
};
export var getUserDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
    var getUserDetailsEndpoint;
    return __generator(this, function (_a) {
        getUserDetailsEndpoint = config.baseApiUrl + "/_api/dev-center/user-details";
        console.log('getUserDetailsEndpoint');
        console.log(getUserDetailsEndpoint);
        return [2 /*return*/, httpClient
                .get(getUserDetailsEndpoint)
                .then(function (_a) {
                var data = _a.data;
                return data;
            })
                .then(getUserDetailsFromResponse)
                .catch(function (error) { return config.sentryClient.captureException(error); })];
    });
}); };
export var fetchBundleApps = function (signedInstance, geo) {
    var geoString = geo ? "&geo=" + geo : '';
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/bundle-apps?lang=en&includeDeleted=true" + geoString, {
            headers: { Authorization: signedInstance },
            withCredentials: true,
        })
            .then(function (res) { return res && res.data && res.data.bundleWebSolutions; })
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var fetchCurrentBundleApps = function (signedInstance, geo) {
    var geoString = geo ? "&geo=" + geo : '';
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/bundle-apps?lang=en&number_of_days=30" + geoString, {
            headers: { Authorization: signedInstance },
            withCredentials: true,
        })
            .then(function (res) { return res && res.data && res.data.bundleWebSolutions; })
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var getRecommendations = function (signedInstance, locale, limit) {
    if (limit === void 0) { limit = 30; }
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/web-solutions/recommended?limit=" + limit + "&lang=" + locale, { headers: { Authorization: signedInstance } })
            .then(function (res) { var _a; return ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.webSolutions) || []; })
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var getRecommendationsWithoutBS = function (signedInstance, locale, limit) {
    if (limit === void 0) { limit = 30; }
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/web-solutions/recommended?limit=" + limit + "&lang=" + locale + "&tags_to_exclude=made-by-wix", { headers: { Authorization: signedInstance } })
            .then(function (_a) {
            var data = _a.data;
            return (data === null || data === void 0 ? void 0 : data.webSolutions) || [];
        })
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var getRandomRecommendations = function (limit, lang, signedInstance) {
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/web-solutions/random-recommendations?limit=" + limit + "&lang=" + lang, { headers: { Authorization: signedInstance } })
            .then(function (_a) {
            var data = _a.data;
            return (data === null || data === void 0 ? void 0 : data.webSolutions) || [];
        })
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var getRecommendationsFromML = function (limit, lang, signedInstance) {
    if (signedInstance) {
        return httpClient
            .get(config.baseApiUrl + "/_api/marketplace-api/v1/web-solutions/app-market-recommender?limit=" + limit + "&lang=" + lang, { headers: { Authorization: signedInstance } })
            .then(function (_a) {
            var data = _a.data;
            return data || {};
        })
            .catch(function (error) { var _a; return (_a = config === null || config === void 0 ? void 0 : config.sentryClient) === null || _a === void 0 ? void 0 : _a.captureException(error); });
    }
    return Promise.resolve([]);
};
export var postDeepLinkEditorCache = function (metaSiteId, data) {
    if (metaSiteId) {
        return httpClient
            .post(config.baseApiUrl + "/_serverless/deep-link-editor-cache/data", data)
            .catch(function (error) { return config.sentryClient.captureException(error); });
    }
    return Promise.resolve([]);
};
export var postLikeToReview = function (appId, reviewId, etag) {
    return httpClient.post(config.baseApiUrl + "/_api/reviews-server/v1/products/" + appId + "/reviews/" + reviewId + "/opinions", { "like": true }, { withCredentials: true,
        headers: { 'If-Match': etag }
    })
        .then(function (_a) {
        var data = _a.data;
        return data.like;
    });
};
export var deleteLikeToReview = function (appId, reviewId, etag, opinionId) {
    return httpClient.delete(config.baseApiUrl + "/_api/reviews-server/v1/products/" + appId + "/reviews/" + reviewId + "/opinions/" + opinionId, { withCredentials: true,
        headers: { 'If-Match': etag }
    });
};
export var getReview = function (appId, reviewId, etag) {
    return httpClient.get(config.baseApiUrl + "/_api/reviews-server/v1/products/" + appId + "/reviews/" + reviewId, { withCredentials: true,
        headers: { 'If-Match': etag }
    })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
//# sourceMappingURL=api.js.map